/**
 * @description: 在线预订
 * @author: hwx
 * @update: lyr
 */
<template>
	<div>
		<div class="book-order" v-show="showList==1">
			<div class="row row-margin">
				<label class="list-label-4">下单时间:</label>
				<div class="col-md-3 list-time">
					<div @click="clearOrderDate" ref="order_time">
						<input type="text" class="form-control laydate-icon" v-model="order_start_date"> -
						<input type="text" class="form-control laydate-icon" v-model="order_end_date">
					</div>
				</div>
				<label class="list-label-4">到店时间:</label>
				<div class="col-md-3 list-time">
					<div @click="clearDate" ref="time">
						<input type="text" class="form-control laydate-icon" :value="startTime"> -
						<input type="text" class="form-control laydate-icon" :value="endTime">
					</div>
				</div>
				<label class="list-label-4">消费门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="list-label-4">包厢类型:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" class="form-control" placeholder="请选择包厢类型" ref="room_type">
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-margin">
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢号" ref="book_room"></select>
                </div>
				<label class="list-label-4">使用状态:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="use_status" data-placeholder="请选择使用状态">
						<option value=" ">全部</option>
						<option value="1">已使用</option>
						<option value="-1">未使用</option>
						<option value="-2">已作废</option>
					</select>
				</div>
				<div class="col-md-1 ct-col book-tit-sel">
					<select class="form-control" ref="query_sel">
						<option value="id">预定单号</option>
						<option value="book_mobile">手机尾号</option>
						<option value="ahead_user_name">微信昵称</option>
						<option value="title">套餐名称</option>
					</select>
				</div>
				<div class="col-md-2 book-con-val">
					<input type="text" class="form-control" v-model="query_val" :placeholder="query_phd">
				</div>
				<label class="list-label-4">订单来源:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="order_from" data-placeholder="请选择订单来源">
						<option value="0">全部</option>
						<option value="5">微信预定</option>
						<option value="6">会员app预定</option>
					</select>
				</div>
			</div>
			<div class="row">
				<label class="list-label-4">实收金额:</label>
				<div class="list-total">{{ total_actual_pay }} 元</div>

				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getExportSet">导出</button>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkQuery">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="book_list"></table>
			</div>
			<!-- 导出设置弹窗 -->
			<div class="ele-hide" ref="export_alert">
				<div class="set-export sel-seldiv">
					<h3>请选择导出报表需要的显示的字段</h3>
					<ul class="set-area clearfix">
						<li>
							<input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
							<label>全选</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="room_type">
							<label>包厢类型</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="room_name">
							<label>包厢号</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="id">
							<label>预定单号</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="title">
							<label>套餐名称</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="timestamp">
							<label>下单时间</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="arrival_time">
							<label>到店时间</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="ahead_user_name">
							<label>预定昵称</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="book_mobile">
							<label>预定手机号</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="actual_pay">
							<label>实收金额</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="refund_amount">
							<label>退款金额</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="pay_scene">
							<label>订单来源</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="use_status">
							<label>使用状态</label>
						</li>
					</ul>
					<h3>请选择导出报表的文件格式</h3>
					<ul class="clearfix">
						<li>
							<input type="radio" v-model='export_type' value="1">
							<label>excel表格</label>
						</li>
						<li>
							<input type="radio" v-model='export_type' value="2">
							<label>pdf文件</label>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- 详情 -->
		<div class="book-detail" v-show="showList==2">
			<bookDetail ref="book_det" @backBkdPre="showList=1"></bookDetail>
		</div>
		<!-- 账单 -->
		<div class="bill-detail" v-show="showList==3">
			<billDetail ref="bill_det" @backBdwPre="showList=1"></billDetail>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import bookDetail from '@/components/book_detail.vue';
	import billDetail from '@/components/bill_detail.vue';
	export default {
		data() {
			return {
				showList: 1,
				order_start_date: "",
				order_end_date: "",
				startTime: "",
				endTime: "",
				roomTypeData: "",
				query_val: "",
				query_phd: "请输入预定单号",
				query_field: "id",
				theOrder: {},
				theGoods: [],
				theRefund: [],
				total_actual_pay: '',

				export_allcheck: false,
				c_export_allcheck: false,
				export_checkModel: [],
				export_checkData: ['room_type', 'room_name', 'id', 'title', 'timestamp', 'arrival_time', 'ahead_user_name', 'book_mobile', 'actual_pay', 'refund_amount', 'pay_scene', 'use_status'],
				export_type: 1,
			}
		},
		components: {
			"bookDetail": bookDetail,
			"billDetail": billDetail,
		},
		watch: {
			export_checkModel: {
				handler: function(val, oldVal) {
					if(this.export_checkModel.length >= this.export_checkData.length) {
						this.export_allcheck = true;
						this.c_export_allcheck = true;
					} else {
						this.export_allcheck = false;
						this.c_export_allcheck = false;
					}
				},
				deep: true
			},
		},
		computed: {
	        business_model() {
	            return this.$store.state.business_model
	        },
	    },
		mounted: function() {
			this.$nextTick(function() {
				var _this = this;
				// 日期
				var myDate = new Date();
				this.IntstartTime = myDate;
				this.IntendTime = new Date(myDate.getTime() + 30 * 24 * 3600 * 1000);
				this.IntstartTime.setHours(8, 0);
				this.IntendTime.setHours(8, 0);
				var timStar = new Date(this.IntstartTime),
				    year = timStar.getFullYear(),
				    month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth()     + 1),
				    day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
				    hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
				    minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
				var timEnd = new Date(this.IntendTime),
				    yearend = timEnd.getFullYear(),
				    monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
				    dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
				    hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
				    minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
				this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
				this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
				this.innitDate();

				this.getShopData();
				$(this.$refs.use_status).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				$(this.$refs.order_from).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				// 下拉选项
				$(this.$refs.query_sel).select2({
					language: "zh-CN",
					minimumResultsForSearch: -1,
					width: '100%'
				}).change(function() {
					_this.query_field = $(this).val();
					_this.query_val = '';
					if(_this.query_field == 'id') {
						_this.query_phd = '请输入预定单号';
					} else if(_this.query_field == 'book_mobile') {
						_this.query_phd = '请输入手机尾号';
					} else if(_this.query_field == 'ahead_user_name') {
						_this.query_phd = '请输入微信昵称';
					} else if(_this.query_field == 'title') {
						_this.query_phd = '请输入套餐名称';
					}
				});
			});
		},
		methods: {
			// 清空下单日期
			clearOrderDate: function() {
				this.orderStartDate = "";
				this.orderEndDate = "";
			},
			// 清空到店日期
			clearDate: function() {
				this.startTime = "";
				this.endTime = "";
			},
			// 初始化日期插件
			innitDate: function() {
				let _this = this;
				console.log("IntstartTime:", _this.IntstartTime )
				$(_this.$refs.time).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: _this.IntstartTime,
					endDate: _this.IntendTime
				}, function(start, end, label) {
					_this.startTime = start.format('YYYY-MM-DD HH:mm');
					_this.endTime = end.format('YYYY-MM-DD HH:mm');
				});

				this.order_start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            	this.order_end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            	console.log("order_start_date:", this.order_start_date)
            	$(_this.$refs.order_time).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: new Date(_this.order_start_date),
					endDate: new Date(_this.order_end_date)
				}, function(start, end, label) {
					console.log("order_time:", start)
					_this.order_start_date = start.format('YYYY-MM-DD HH:mm');
					_this.order_end_date = end.format('YYYY-MM-DD HH:mm');
				});
			},
			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							arr.shift();
							$(_this.$refs.shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN"
							}).on("select2:select", function(e) {
								$(_this.$refs.room_type).val("").trigger('change');
								_this.getRoomTypeData(e.params.data.id);
								// 包厢号
                                $(_this.$refs.book_room).val('').trigger('change');
                                _this.getRoomdata(e.params.data.id);
							});
							_this.getRoomTypeData($(_this.$refs.shop).val());
							// 包厢号
                            $(_this.$refs.book_room).val('').trigger('change');
                            _this.getRoomdata($(_this.$refs.shop).val());
							_this.innitTable();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 包厢类型数据
			getRoomTypeData: function(shop_id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id || ""
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getRoomType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.roomTypeData = data.response.result.data;
							_this.initRoomType();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 初始化包厢类型
			initRoomType: function() {
				let _this = this;
				$(_this.$refs.room_type).bsSuggest("destroy");
				$(_this.$refs.room_type).bsSuggest({
					data: {
						value: _this.roomTypeData
					},
					ignorecase: true,
					showHeader: false,
					showBtn: false,
					delayUntilKeyup: true,
					effectiveFields: ["name"],
					idField: "id",
					keyField: "name"
				}).on('onSetSelectValue', function(e, keyword, data) {

				});
			},
			// 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.book_room).html("");
                            $(_this.$refs.book_room).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },



			// 预订单表格
			innitTable: function() {
                let _this = this;
                $(_this.$refs.book_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "room_type",
                        title: "包厢类型",
                        width: "5%",
                        valign: 'middle'
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "id",
                        title: "预定单号",
                        width: "10%",
                        valign: 'middle'
                    }, {
                        field: "title",
                        title: "套餐名称",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "timestamp",
                        title: "下单时间",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "arrival_time",
                        title: "到店时间",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "ahead_user_name",
                        title: "预定昵称",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "book_mobile",
                        title: "预定手机号",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "actual_pay",
                        title: "实收金额",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "refund_amount",
                        title: "退款金额",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "pay_scene",
                        title: "订单来源",
                        width: "8%",
                        valign: 'middle'
                    }, {
                        field: "use_status",
                        title: "使用状态",
                        width: "5%",
                        valign: 'middle'
                    }, {
                        title: "操作",
                        width: "12%",
                        valign: 'middle',
                        events: {
                            'click .detail': function(e, value, row) {
                                _this.$refs.book_det.getBkdDetail(row.id);
								_this.showList = 2;
                            },
                            'click .bill': function(e, value, row) {
                                _this.$refs.bill_det.getBdwDetail(row.bill_no);
								_this.showList = 3;
                            },
                            'click .refund': function(e, value, row) {
                                layer.confirm('确认退款？退款后款项将原路退回！', {
									btn: ['确定', '取消'],
									title: '提示',
								}, function() {
									_this.doRefund(row.id);
								});
                            },
                        },
                        formatter: function(value, row, index) {
                        	if (row.use_status == '已使用') {
                        		return '<span class="text-blue detail">详情</span> <span class="text-blue bill">账单</span>'
                        	}if (_this.business_model == 2 && row.status == 1) {
                    			return '<span class="text-blue detail">详情</span><span class="text-blue refund">退款</span>'
                    		}else {
                        		return '<span class="text-blue detail">详情</span>'
                    		}
                        }
                    }],
                });
            },
            // 表格数据
            getList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.shop).val(),
                    room_type_id = $(_this.$refs.room_type).attr("data-id"),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "order_start_date": _this.order_start_date,
                            "order_end_date": _this.order_end_date,
                            "start_date": _this.startTime,
                            "end_date": _this.endTime,
                            "shop_id": shop_id || "",
                            "room_type_id": room_type_id,
                            "room_id": $.trim($(_this.$refs.book_room).val()),
                            "use_status": $.trim($(_this.$refs.use_status).val()),
                            "pay_scene": $(_this.$refs.order_from).val(),
                            "key_word": _this.query_field,
                            "search_word": _this.query_val
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Book/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.book_list
                            });
                            _this.total_actual_pay = data.response.result.total_amount;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
			// 查询
			clkQuery: function() {
				$(this.$refs.book_list).bootstrapTable("destroy");
				this.innitTable();
			},
			// 退款
			doRefund(id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Book/refund",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.book_list).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

            // 获取导出设置
			getExportSet: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"report_type": "Book/export"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FinanceReport/getExportSet",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(data.response.result) {
								_this.export_checkModel = data.response.result.export_fields;
								_this.export_type = data.response.result.export_type;
							} else {
								_this.export_checkModel = _this.export_checkData;
								_this.export_type = 1;
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});

				// 弹窗
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['导出设置', true],
					area: ['830px', ''], // 宽高
					content: $(_this.$refs.export_alert)
				}, function() {
					_this.exportList();
				});
			},
			// 导出字段全选
			exportCheckedAll: function() {
				let _this = this;
				_this.export_allcheck = _this.c_export_allcheck;
				if(!_this.export_allcheck) { // 实现全选
					_this.export_checkModel = [];
					_this.export_checkData.forEach(function(item) {
						_this.export_checkModel.push(item);
					});
				} else { // 实现反选
					_this.export_checkModel = [];
				}
			},
			// 导出
			exportList: function() {
				let _this = this,
					shop_id = $(_this.$refs.shop).val(),
					room_type_id = $(_this.$refs.room_type).attr("data-id");
				let export_fields = JSON.stringify(_this.export_checkModel);
				window.location.href = Vue.ctUrl + "Book/export?" +
					"&order_start_date=" + _this.order_start_date + 
					"&order_end_date=" + _this.order_end_date +
					"&start_date=" + _this.startTime +
					"&end_date=" + _this.endTime +
					"&shop_id=" + shop_id +
					"&room_type_id=" + room_type_id +
                    "&room_id=" + $.trim($(_this.$refs.book_room).val()) +
					"&use_status=" + $.trim($(_this.$refs.use_status).val()) +
					"&pay_scene=" + $(_this.$refs.order_from).val() +
					"&key_word=" + _this.query_field +
					"&search_word=" + _this.query_val +
					"&export_fields=" + export_fields +
					"&export_type=" + _this.export_type;
				//debugger;
				layer.msg("导出成功！");
				layer.closeAll();
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.book-order {
		.book-tit-sel {
			width: 90px;
			padding: 0;
		}
		.book-con-val {
			padding-left: 0;
			margin-left: -1px;
		}
		.pull-right {
			button {
				margin: 0 0 0 30px;
			}
		}
		.set-export {
			padding: 0 20px 20px;
			h3 {
				font-size: 16px;
			}
			li {
				float: left;
				width: 20%;
			}
		}
	}
</style>